import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SessionService } from '../../shared/services/session.service';
import { SweetAlertService } from '../services/sweet-alert.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private sessionService: SessionService, 
    private router: Router,
    private swal: SweetAlertService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userViews = this.sessionService.getUserViews();
    const url = state.url;

    if(!this.sessionService.isAuth()) {
      this.swal.warning('Debes iniciar sesión para acceder a esta página');
      this.router.navigate(['/login']);
      return false;
    }

    if (!this.isAuthorized(url, userViews)) {
      this.router.navigate(['/app/unauthorized']);
      return false;
    }

    return true;
  }

  private isAuthorized(url: string, views: string[][]): boolean {
    const urlParts = url.split('/').filter(part => part);

    if(url.startsWith('/app/unauthorized')) return true;

    if(!views?.length) return false;

    for(let i = 0; i < urlParts.length; i++) {
        const part = urlParts[i];
        
        const exist = views.find(view => {
            if(view[i] === '{value}') return true;
            return view[i] === part;
        });

        if(!exist) return false;
    }

    return true ;
  }
}